var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosofteam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 179,
    viewBox: "0 0 179 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.49 177.3C137.898 177.3 177.14 138.058 177.14 89.65C177.14 41.2423 137.898 2 89.49 2C41.0822 2 1.84 41.2423 1.84 89.65C1.84 138.058 41.0822 177.3 89.49 177.3Z",
    fill: "url(#paint0_linear_1_21)",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.86 88.69V122.6",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.48 70.14L88.86 89.33",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.59 70.59L89.22 89.79",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3 147.87L33.53 121.95L33.2 58.94L54.31 71.74L54.85 108.72L86.3 124.2V147.87Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.24 147.95L144 122.04L144.34 59.03L123.23 71.82L122.69 108.81L91.24 124.28V147.95Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.96 54.46L88.86 26.31L34.48 54.46L56.23 67.26L88.22 49.98L120.2 67.26L141.96 54.46Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_21",
    x1: 89.39,
    y1: 130.29,
    x2: 89.85,
    y2: -50.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4FA8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2482BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F74BC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosofteam);
export default __webpack_public_path__ + "static/media/LOGOSOFTEAM.c034dcc477d5e54c176114232743a5e8.svg";
export { ForwardRef as ReactComponent };